// Shared motion + typography presets for the tenant public site.
// Reduce motion footprint by importing only what's needed where used.

export const easings = {
    soft: [0.22, 1, 0.36, 1],         // expo-out style
    snap: [0.65, 0, 0.35, 1],          // crisp in-out
    decel: [0, 0, 0.2, 1],             // material decelerate
    overshoot: [0.34, 1.56, 0.64, 1]   // gentle overshoot
};

export const springs = {
    soft: { type: 'spring', stiffness: 120, damping: 20, mass: 0.8 },
    snap: { type: 'spring', stiffness: 220, damping: 28, mass: 0.7 },
    bouncy: { type: 'spring', stiffness: 320, damping: 22, mass: 0.5 }
};

// Common reveal-on-scroll variants. Use with `whileInView` + `viewport={viewportOnce}`.
export const fadeUp = {
    hidden: { opacity: 0, y: 28 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, ease: easings.soft }
    }
};

export const fadeIn = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { duration: 0.5, ease: easings.soft } }
};

export const stagger = (delay = 0.08) => ({
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: { staggerChildren: delay, delayChildren: 0.05 }
    }
});

export const viewportOnce = { once: true, margin: '-80px 0px' };

// Detect prefers-reduced-motion (SSR-safe).
export function prefersReducedMotion() {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
